/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-19 15:30:32
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-20 15:22:34
 * @FilePath: \合联\oms\src\api\workOrderManagement\list.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/work/oms/order'

export const apis = buildApi({
  get: [name + '/index&list', '/common/work/category&category', name + '/record/:id&detail', '/common/workStatus'],
  post: [name + '/complete'],
  upload: [name + '/reply', name + '/upload'],
})